<mode-format-builder-title
  [field]="field"
  [titleFormat]="title"
  [titleCheckboxLabel]="'Show axis title'"
  [titleInputLabel]="'Axis title'"
  (update)="updateTitle($event)"
>
</mode-format-builder-title>
<mode-format-builder-axis-labels
  *ngIf="field.isBinned"
  [binnedAxisLabel]="binnedAxisLabels"
  (update)="updateBinnedAxisLabels($event)"
></mode-format-builder-axis-labels>
<mode-format-builder-rotation [angle]="label.rotation" (update)="updateRotation($event)">
</mode-format-builder-rotation>
<ng-container *ngIf="field.isNumeric && !field.isBinned">
  <mode-format-builder-range
    [range]="scale.range"
    (update)="
      updateScale({
        range: $event
      })
    "
  ></mode-format-builder-range>
</ng-container>
<mode-format-shortcut-menu
  [field]="field"
  [format]="scale.default"
  (update)="
    updateScale({
      default: $event
    })
  "
></mode-format-shortcut-menu>
<mode-format-builder-scale
  *ngIf="field.isNumeric && !field.isBinned"
  [axisScale]="scale.interpolation"
  (update)="
    updateScale({
      interpolation: $event
    })
  "
>
</mode-format-builder-scale>
<ng-container *ngIf="field.dataType === 'TIMESTAMP'">
  <label class="label-form-control select-label">Range</label>
  <div class="field-group">
    <mode-date-picker
      class="axis-range-input"
      data-test="axis-range-date-min"
      [date]="axisStartDate"
      [placeholder]="'min'"
      (dateChange)="onAxisStartDateChange($event)"
    ></mode-date-picker>
    <span class="range-separator">&ndash;</span>
    <mode-date-picker
      class="axis-range-input"
      data-test="axis-range-date-max"
      [date]="axisEndDate"
      [placeholder]="'max'"
      (dateChange)="onAxisEndDateChange($event)"
    ></mode-date-picker>
  </div>
</ng-container>
